import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "login",
  class: "login static-space-top auth-page"
};
const _hoisted_2 = {
  class: "row justify-content-center section-margin"
};
const _hoisted_3 = {
  class: "col-xl-4 col-lg-5 col-md-6 col-11"
};
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "row mb-4"
};
const _hoisted_7 = {
  class: "col d-flex justify-content-end align-items-center"
};
const _hoisted_8 = {
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
  key: 0,
  class: "spinner-border text-dark",
  role: "status"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[8] || (_cache[8] = _createElementVNode("h1", {
    class: "title mb-0"
  }, "Sign in", -1)), $setup.errorMessage !== null ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", {
    innerHTML: $setup.errorMessage
  }, null, 8, _hoisted_5), _createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.removeErrorMessage && $setup.removeErrorMessage(...args)),
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "alert",
    "aria-label": "Close"
  })])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["form-group email-input", {
      effectStyles: $setup.loginState.email
    }])
  }, [_createVNode(_component_Input, {
    class: _normalizeClass({
      error: $setup.loginValiadtion.email.$errors.length
    }),
    label: "Email",
    name: "email",
    type: "email",
    icon: "mail",
    modelValue: $setup.loginState.email,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.loginState.email = $event),
    error: $setup.loginValiadtion.email.$errors,
    value: $setup.loginState.email
  }, null, 8, ["class", "modelValue", "error", "value"])], 2), _createElementVNode("div", {
    class: _normalizeClass(["form-group", {
      effectStyles: $setup.loginState.password
    }])
  }, [_createVNode(_component_Input, {
    class: _normalizeClass({
      error: $setup.loginValiadtion.password.$errors.length
    }),
    label: "Password",
    name: "password",
    type: "password",
    icon: "lock",
    modelValue: $setup.loginState.password,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.loginState.password = $event),
    error: $setup.loginValiadtion.password.$errors,
    value: $setup.loginState.password
  }, null, 8, ["class", "modelValue", "error", "value"])], 2), _createElementVNode("div", _hoisted_6, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "col"
  }, [_createElementVNode("div", {
    class: "form-check"
  }, [_createElementVNode("input", {
    class: "form-check-input",
    type: "checkbox",
    value: "",
    id: "form2Example31"
  }), _createElementVNode("label", {
    class: "form-check-label remember-me",
    for: "form2Example31"
  }, " Remember me ")])], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("h6", null, [_createVNode(_component_router_link, {
    to: "/forgot",
    class: "forgot-link"
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Forgot password?")])),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_router_link, {
    to: "/register",
    class: "btn-signup"
  }, {
    default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" Create account ")])),
    _: 1
  }), _createElementVNode("button", {
    class: "btn btn-primary blue-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.loginSubmit && $setup.loginSubmit(...args)),
    disabled: $setup.loading
  }, [$setup.loading ? (_openBlock(), _createElementBlock("div", _hoisted_10)) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createTextVNode(" Sign in "))], 8, _hoisted_9)])])])]);
}